<template>
    <div>
        <top></top>
        <Transform></Transform>
    </div>
</template>

<script>
import Top from '../components/common/Top.vue'
import Transform from '../components/Transform.vue'
export default {
    name: 'Transform-view',
    components: {
        Top, Transform
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
